import axios from "axios";
import qs from "qs";
import merge from "lodash/merge";
import VueCookie from "vue-cookie";
import { Message } from "element-ui";

const http = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json; charset=utf-8"
    }
});
/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = actionName => {
    // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
    return process.env.VUE_APP_BASEURL + actionName;
};
http.uadornUrl = actionName => {
    // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
    return process.env.VUE_APP_UNIVURL + actionName;
};
/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
    var defaults = {
        t: new Date().getTime()
    };
    return openDefultParams ? merge(defaults, params) : params;
};
/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefultdata = true, contentType = "json") => {
    var defaults = {
        t: new Date().getTime()
    };
    data = openDefultdata ? merge(defaults, data) : data;
    return contentType === "json" ? JSON.stringify(data) : qs.stringify(data);
};

function mountToken(config) {
    config.headers.token = VueCookie.get("procuretoken") || "";
}

function mountTimeStamp(config) {
    if (config.method.toUpperCase() == "POST") {
        // if(!Array.isArray(config.data)){
        //     let finallyData = merge(
        //         {
        //             t: new Date().getTime()
        //         },
        //         config.data || {}
        //     );
        //     config.data = finallyData;
        // }
    } else if (config.method.toUpperCase() == "GET") {
        let finallyParams = merge(
            {
                t: new Date().getTime()
            },
            config.params || {}
        );
        config.params = finallyParams;
    }
}

// 添加请求拦截器
http.interceptors.request.use(
    function (config) {
        // 挂载请求头token
        mountToken(config);
        if (!config.notime) {
            // 挂载时间戳请求参数
            mountTimeStamp(config);
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);
const codeWhiteList = [0, '0', 200, -10001, -1];
const errorCodeList = [401, 500];
// 添加响应拦截器
http.interceptors.response.use(
    function (res) {
        if (codeWhiteList.includes(res.data.code)) {
            return res;
        } else if (errorCodeList.includes(res.data.code)) {
            Message.error(res.data.msg);
        } else if (res.config.responseType == "arraybuffer") {
            return res;
        } else if (
            res.headers["content-type"] ==
            "application/vnd.ms-excel;charset=UTF-8"
        ) {
            return res;
        } else {
            return Promise.reject(res.data);
        }
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default http;



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js